// extracted by mini-css-extract-plugin
module.exports = {"title":"remindPhonePopup_title__2STHr","heart":"remindPhonePopup_heart__-i1SK","text":"remindPhonePopup_text__1Y2L0","button":"remindPhonePopup_button__1O7IP"};